
export const FETCH_GALLERY = 'FETCH_GALLERY';
export const FETCH_MOMENTS = 'FETCH_MOMENTS';
